<template>

    <div class="input-container">

        <label v-if="label" class="form-label">{{ label }}</label>

        <div class="input-group mb-0 bg-light-subtle rounded-3">

            <span class="input-group-text text-muted" v-if="icon">
                <i :class="icon"></i>
            </span>
            

            <template v-if="!maskType">
                <input class="form-control form-control-lg border-light bg-light-subtle" :type="inputType" :placeholder="placeHolder" :value="modelValue" @input="$emit('update:modelValue', $event.target.value)" :required="required" :min="min" :max="max" :step="step" />
            </template>

            <template v-else>
                
                <template v-if="maskType != 'money'">
                    <input v-mask="getPathMask()" class="form-control form-control-lg border-light bg-light-subtle" :type="inputType" :placeholder="placeHolder" :value="modelValue" @input="$emit('update:modelValue', $event.target.value)" :required="required" :min="min" :max="max" :step="step" />
                </template>
                    

                
                <template v-else>
                    <input :model-modifiers =" { number: true } " v-model.number="localValue" v-money3="money" class="form-control form-control-lg border-light bg-light-subtle" :type="inputType" :placeholder="placeHolder" @input="$emit('update:modelValue', $event.target.value)" :required="required" :min="min" :max="max" :step="step" />
                </template>
                    

            </template>
                

            <span v-if="type === 'password'" @click="mudarVisibilidadeSenha()" class="input-group-text cursor-pointer">
                <i :class="classeSenhaVisibilidade()"></i>
            </span>

        </div>

    </div>

</template>

<script>
export default {
    props: {
        label: {
            type: String
        },
        type: {
            type: String,
            default: 'text',
        },
        icon: {
            type: String,
        },
        placeHolder: {
            type: String,
            default: '',
        },
        required: {
            type: Boolean,
            default: false,
        },
        modelValue: {
            type: [String, Number],
            default: ''
        },
        maskType: {
            type: [String],
            default: ''
        },
        min: {
            type: [String],
            default: ''
        },
        max: {
            type: [String],
            default: ''
        },
        step: {
            type: [String],
            default: ''
        }
    },
    data() {
        return {
            senhaVisivel: false,
            money: {
                prefix: 'R$ ',       // já coloquei R$ no span, se quiser pode colocar aqui
                thousands: '.',   // separador de milhar
                decimal: ',',     // separador decimal
                precision: 2,      // casas decimais
                masked: false
            },
            localValue: this.modelValue
        };
    },
    watch: {
        localValue(newVal) {
            this.$emit('update:modelValue', newVal) // manda pro pai
        },
        modelValue(newVal) {
            this.localValue = newVal // sincroniza quando o pai muda
        }
    },
    computed: {
        inputType() {
            if (this.type === 'password') {
                return this.senhaVisivel ? 'text' : 'password';
            }
            return this.type;
        }
    },
    methods: {
        mudarVisibilidadeSenha() {
            this.senhaVisivel = !this.senhaVisivel;
        },
        classeSenhaVisibilidade(){
            return (this.senhaVisivel) ? 'ri-eye-off-line' : 'ri-eye-line';
        },
        getPathMask(){

            switch (this.maskType) {
                case 'cpf':
                    return '###.###.###-##'
                case 'cnpj':
                    return '##.###.###/####-##'
                case 'phone':
                    return ['(##) ####-####', '(##) #####-####']
                case 'money':
                    return '###.###.###.###.###.###.###.###,##'
            }

            return ''
        }
    },
};
</script>